import React from "react";
import { QuestionAnswer } from "../QuestionAnswer";
import { QuestionEditorWithImages } from "../../../../QuestionEditorWithImages";

interface QuestionEditorsSectionProps {
	prefix: string;
}

export default function QuestionEditorsSection({ prefix }: QuestionEditorsSectionProps) {
	return (
		<>
			<QuestionEditorWithImages
				controllerName={`${prefix}problem`}
				editorTitle={"Условие задачи"}
				displayTitle={"Отображение условия"}
				height={"200px"}
			/>
			<QuestionEditorWithImages
				controllerName={`${prefix}hint`}
				editorTitle={"Подсказка"}
				displayTitle={"Отображение подсказки"}
				height={"200px"}
			/>
			<QuestionEditorWithImages
				controllerName={`${prefix}solution`}
				editorTitle={"Решение"}
				displayTitle={"Отображение решения"}
				height={"300px"}
			/>
			<QuestionAnswer prefix={prefix} />
		</>
	);
}
